import { useLocation } from "react-router-dom";
import { Table } from "../../features/Table";
import { type Keyword, keywords_columns } from "./columns";
import { FilterKeywords } from "./filter";

const client = "ia-quantilia";
const table_name = "keywords";

export const KeywordsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<Keyword, Keyword>
      label="Keywords"
      client={client}
      table_name={table_name}
      columns={keywords_columns}
      disable_translations_request={true}
      filter={<FilterKeywords />}
      columnVisibilityInit={{
        id: false,
      }}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
